// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__30Lt8","inner":"Footer_inner__z_Osh","nextIcon":"Footer_nextIcon__2SDJt","innerLeft":"Footer_innerLeft__1JA9x"};